import type {IconStatusProps} from 'shells/icon-status/icon-status';

export const getIconStatus = (isVerified: boolean, context: string): IconStatusProps => {
    const level = isVerified ? 'verified' : 'pending';
    switch (context) {
        case 'sso':
            return {
                level: level,
                text: isVerified ? 'Verified' : 'Not verified',
            };
        case 'pinned':
            return {
                level: level,
                text: isVerified ? 'Pinned' : 'Not pinned',
            };
        default:
            return {
                level: 'pending',
                text: '',
            };
    }
};

export function getDataTipText(canDisableSso: boolean): string {
    if (!canDisableSso) {
        return 'You need admin privileges and SSO exemption to disable this feature.';
    }

    return '';
}
